export enum UserRoleType {
  PowerUserWithReadOnly = 1,
  Admin = 3,
  PowerUserWithEdit = 4,
  Reviewer = 5,
  WorkflowOnly = 6,
}
